import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { LockGlyph12Icon } from 'assets/icons'

const EventListItemCard = ({
   borderColor,
   coverMedia,
   date,
   linkTo,
   location,
   name,
   numAttendees,
   pastEvent,
   privacy,
   subtitle,
   summary,
   startDate,
   startTime,
   textColor,
   virtual
}) => {
   let month = null
   let day = null
   if (date) {
      const dateObj = new Date(date)
      month = dateObj.toLocaleString('en-us', { month: 'short' })
      day = dateObj.getDate()
   }

   return (
      <Link to={linkTo}>
         <View
            position="relative"
            paddingTop="56.25%"
            backgroundColor={!coverMedia && 'rgba(100,100,100,0.3)'}
            backgroundImage={coverMedia && `url(${coverMedia?.file.thumbnailUrlW480})`}
            backgroundSize="cover"
            backgroundPosition="center center"
            backgroundRepeat="no-repeat"
            borderRadius="3px"
            marginBottom="15px[a-d] 20px[e-f]">
            {['admin', 'draft', 'private'].includes(privacy) && (
               <View
                  display="flex"
                  alignItems="center"
                  position="absolute"
                  top="10px"
                  left="10px"
                  backgroundColor={privacy === 'draft'
                     ? 'rgba(247, 183, 124, 1)'
                     : 'rgba(0,0,0,0.3)'
                  }
                  borderRadius="2px"
                  padding="5px 5px">
                  {privacy !== 'draft' && (
                     <View display="flex" alignItems="center" marginRight="5px">
                        <LockGlyph12Icon
                           color="rgba(255,255,255,0.5)"
                           width="7px"
                           height="7px"
                        />
                     </View>
                  )}
                  <Text
                     size="0.7"
                     lineHeight="100%"
                     color={privacy === 'draft' ? '#000' : 'rgba(255,255,255,0.8)'}
                     weight="medium"
                     transform="uppercase">
                     {privacy}
                  </Text>
               </View>
            )}
         </View>
         <View paddingBottom="60px">
            <View marginTop="2px">
               <Text
                  size="2.5[a-c] 2[d] 2.5[e-f]"
                  lineHeight="120%"
                  weight="medium"
                  color={textColor}>
                  {name}
               </Text>
            </View>
            {(subtitle || summary) && (
               <View
                  margin="10px 0 0 0[a-d] 15px 0 0 0[e-f]"
                  maxHeight="55px"
                  opacity="0.6"
                  style={{
                     overflow: 'hidden',
                     textOverflow: 'ellipsis'
                  }}>
                  <Text
                     size="2"
                     lineHeight="130%"
                     color={textColor}>
                     {subtitle}
                     {!subtitle && (
                        <div dangerouslySetInnerHTML={{ __html: summary }} />
                     )}
                  </Text>
               </View>
            )}
            {numAttendees > 5 && (
               <View marginTop="10px" opacity="0.4">
                  <Text
                     size="1.5"
                     lineHeight="120%"
                     weight="medium"
                     color={textColor}>
                     {`${numAttendees} people ${pastEvent ? 'attended' : 'attending'}`}
                  </Text>
               </View>
            )}
            <View display="flex" marginTop="15px">
               {date && (
                  <View
                     flex="0 0 auto"
                     float="left"
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     width="34px"
                     height="34px"
                     top="10px"
                     left="10px"
                     borderRadius="3px"
                     border={`1px solid ${borderColor}`}
                     textAlign="center"
                     marginTop="2px"
                     marginRight="10px">
                     <div>
                        <Text
                           color={textColor}
                           lineHeight="120%"
                           size="0.7"
                           weight="medium"
                           transform="uppercase">
                           {month}
                        </Text>
                        <Text color={textColor} lineHeight="110%" weight="medium" size="1">
                           {day}
                        </Text>
                     </div>
                  </View>
               )}
               <View>
                  {startDate && (
                     <View opacity="0.6">
                        <Text
                           size="1.5"
                           lineHeight="150%"
                           letterSpacing="-0.3px"
                           weight="medium"
                           color={textColor}>
                           {startDate}
                           {startTime && ` — ${startTime}`}
                        </Text>
                     </View>
                  )}
                  {!virtual && (location.city || location.state) && (
                     <View opacity="0.4">
                        <Text
                           size="1.5"
                           lineHeight="150%"
                           color={textColor}>
                           {`${location.city}${location.city && location.state && ', '}${location.state}`}
                        </Text>
                     </View>
                  )}
                  {virtual && (
                     <View
                        display="inline-block"
                        padding="2px 5px"
                        borderRadius="2px"
                        border="1px solid #eb8044">
                        <Text
                           size="0.9"
                           lineHeight="100%"
                           color="#eb8044">
                           Online
                        </Text>
                     </View>
                  )}

               </View>
            </View>
         </View>
      </Link>
   )
}

EventListItemCard.propTypes = {
   borderColor: PropTypes.string,
   coverMedia: PropTypes.object,
   date: PropTypes.string,
   linkTo: PropTypes.string.isRequired,
   location: PropTypes.object,
   name: PropTypes.string.isRequired,
   numAttendees: PropTypes.number.isRequired,
   pastEvent: PropTypes.bool,
   privacy: PropTypes.string.isRequired,
   startDate: PropTypes.string,
   startTime: PropTypes.string,
   subtitle: PropTypes.string,
   summary: PropTypes.string,
   textColor: PropTypes.string,
   virtual: PropTypes.bool
}

EventListItemCard.defaultProps = {
   borderColor: '#e5e5e5',
   coverMedia: undefined,
   date: undefined,
   location: undefined,
   pastEvent: false,
   startDate: undefined,
   startTime: undefined,
   subtitle: undefined,
   summary: undefined,
   textColor: '#000',
   virtual: false
}

export default EventListItemCard
